
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compress-jpg",
      function () {
        return require("private-next-pages/compress-jpg/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compress-jpg"])
      });
    }
  